import { graphql } from "@/gql";

export const supplierReportQuery = graphql(`
  query SupplierReportQuery($rangeStart: String!, $rangeEnd: String!) {
    supplierReport(range_start_date: $rangeStart, range_end_date: $rangeEnd) {
      supplier_id
      supplier_name

      currency
      charge_per_move_amount
      booking_fee_amount

      revenue_per_booking
      revenue_per_booking_previous
      revenue_per_booking_trend

      total_relocations
      total_bookings
      current_listings_count

      successful_bookings
      successful_percentage

      pending_bookings
      pending_percentage

      supplier_cancelled_bookings
      supplier_cancelled_percentage

      customer_cancelled_bookings
      customer_cancelled_percentage

      admin_cancelled_bookings
      admin_cancelled_percentage

      other_bookings
      other_percentage

      avg_hours_to_confirm
      avg_weekly_sales
      avg_booking_value
      avg_extra_days
      clearance_rate

      last_listing_time
      listing_frequency
      region
    }
  }
`);
